import { cardCdnURL } from "components/utils/cdn";

export const sampleGroupCardMagicLink = "https://birthdayalarm.com/card/read/ux9xixfb";

export const isDev = ["dev", "dev-nt", "dev-md"].includes(BDAY_ENV);

export const isProd = ["prod"].includes(BDAY_ENV);

export const isLocal = !isDev && !isProd;

export const jifitiScriptUrl = isProd ? "https://sdk.progifts.io/sdk/v1/giftit.js" : "https://d6p9ns0t4edbh.cloudfront.net/sdk/v1/giftit.js";

export const jifitiPartnerId = 8081;

export const getWebVersion = () => {
  return BDAY_VERSION;
};

export const getEnvironment = () => {
  return BDAY_ENV;
};

export const getBrowserVisibilityProp = () => {
  if (typeof document.hidden !== "undefined") {
    // Opera 12.10 and Firefox 18 and later support
    return "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    return "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitvisibilitychange";
  }
};

export const getBrowserDocumentHiddenProp = () => {
  if (typeof document.hidden !== "undefined") {
    return "hidden";
  } else if (typeof document.msHidden !== "undefined") {
    return "msHidden";
  } else if (typeof document.webkitHidden !== "undefined") {
    return "webkitHidden";
  }
};

export const getIsDocumentHidden = () => {
  return !document[getBrowserDocumentHiddenProp()];
};

export const getLogoURL = () => {
  if (isLocal) {
    return cardCdnURL("logo/logo_red.png?v=1");
  }
  if (isDev) {
    return cardCdnURL("logo/logo_green.png?v=1");
  }
  return cardCdnURL("logo/logo.png?v=1");
};

export const loadStorageState = (key) => {
  try {
    const serializedState = window.localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveStorageState = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    window.localStorage.setItem(key, serializedState);
  } catch (err) {
    //ignore write errors
  }
};
